import React from 'react';
import './CommentBox.scss';
import CommentForm from './CommentForm';
import CommentsThread from './CommentsThread';

class CommentBox extends React.Component{

  constructor(){
    super(...arguments);
    this.state = {
      addComment: false
    };
    this.onPost = this.onPost.bind(this);
    this.addComment = this.addComment.bind(this);
    this.onAddNeedingApproval = this.onAddNeedingApproval.bind(this);
  }

  onPost(){
    this.setState({
      addComment: false,
      message: null
    });
  }

  onAddNeedingApproval(){
    this.setState({
      addComment: false,
      message: 'Thank you! Your comment was added, but will not appear publicly until approved by the site administrator.'
    });
  }

  addComment(){
    this.setState({
      addComment: true,
      message: null
    });
  }

  render(){
    let showComments = this.props.parent.commentsAllowed || this.props.parent.get('comments').length > 0 || FW.store.get('has-comments');

    return showComments ? <div className="comments-wrapper">
      {!this.props.parent.get('hide_title') ? <h4>{this.props.title ? this.props.title : "Comments"}</h4> : null}
      <div className="row">
        <div className="col-md-12">
          {this.state.addComment ? <CommentForm section={this.props.section} onAdd={this.onPost} onAddNeedingApproval={this.onAddNeedingApproval} parent={this.props.parent} /> : <div>
            {this.props.parent.commentsAllowed ? <p>{!FW.store.get('post-has-comments') && this.props.parent.get('comments').length === 0 ? <span>{this.props.emptyMessage ? this.props.emptyMessage : 'There are no comments on this post. Join the discussion!'}</span> : null}</p> : null}
            {this.props.parent.commentsAllowed ? <p style={{textAlign: 'center'}}><span className="btn btn-primary btn-lg" id="commentNowButton" onClick={this.addComment}>{this.props.title ? 'Post' : 'Comment'} Now</span></p> : null}
            {this.state.message ? <p style={{textAlign: 'center', padding: 15}} className="lead">{this.state.message}</p> : null}
          </div>}
        </div>
      </div>
      <CommentsThread parent={this.props.parent} onChildUpdate={() => {
        this.forceUpdate();
      }} />
    </div> : null;
  }

}

export default CommentBox;
